import {connect} from '../../app/connect';
import TemplateEditModal from './TemplateEditModal';
import {actions as formActions} from 'react-redux-form';
import {
  getPendingTemplate,
  getPendingTemplateForm,
  getAppLoading,
  getFieldIssueMandatoryDataLoading,
  getIssueAttributesMappingEntitiesMap,
  getIssueTypesAdminEntitiesMap
} from '../../app/selectors';
import {createTemplateAction, updateTemplateAction} from '../../app/actions';

const mapStateToProps = state => ({
  pendingTemplate: getPendingTemplate(state),
  pendingTemplateForm: getPendingTemplateForm(state),
  issueCustomAttributesMappings: getIssueAttributesMappingEntitiesMap(state),
  fieldIssueTypeEntitiesMap: getIssueTypesAdminEntitiesMap(state),
  loading: getAppLoading(state) || getFieldIssueMandatoryDataLoading(state)
});

const {
  reset: resetFormAction,
  resetValidity: resetValidityFormAction,
  setSubmitFailed: setSubmitFailedFormAction,
  change: changeFormValueAction,
  setErrors: setErrorsFormAction
} = formActions;

const mapDispatchToProps = {
  resetFormAction,
  resetValidityFormAction,
  setSubmitFailedFormAction,
  changeFormValueAction,
  setErrorsFormAction,
  createTemplateAction,
  updateTemplateAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateEditModal);
